import React from "react";
import Skeleton from "../../skeleton";

const Mobile = () => (

	<>
		<div className="card-skeleton-tab-article">
			<div className="card-skeleton-tab-article__section-article">
				<Skeleton
					width="200px"
					height="20px"
				/>
				<div className="card-skeleton-tab-article__article">
					{Array.from({ length: 6 }, (value, id) => (
						<div key={id} className="card-skeleton-tab-article__article-data">
							<Skeleton
								width="100px"
								height="66.67px"
							/>
							<div className="card-skeleton-tab-article__article-description">
								<Skeleton
									width="80px"
									height="16px"
								/>
								<Skeleton
									width="160px"
									height="16px"
								/>
							</div>
						</div>
					))}
				</div>
				<div className="card-skeleton-tab-article__article-button">
					<Skeleton
						width="240px"
						height="40px"
						margin="auto"
					/>
				</div>
			</div>
		</div>
		<style jsx>
			{`
				.card-skeleton-tab-article{
					max-width: 480px;
				}
				.card-skeleton-tab-article__section-article {
					margin-top: 12px;
				}
				.card-skeleton-tab-article__article-data {
					display: flex;
					align-items: center;
					gap: 8px;
				}
				.card-skeleton-tab-article__article {
					margin-top: 18px;
				}
				.card-skeleton-tab-article__article-button{
					margin-top: 41px;
					display: flex;
					align-items: center;
					justify-content: center;
				}

		`}
		</style>
	</>

);

export default Mobile;
